import React, { Component } from "react";
import ReactDOM from 'react-dom';
import WidgetSelection from './WidgetSelection.js';
//import "bootstrap/dist/css/bootstrap.css";
import "./styles/App.css";
import "./styles/bootstrap-iso.css";
// .sv {
//     @import 'bootstrap-4.0.0-beta/scss/bootstrap.scss';
//     box-sizing: border-box;
// } 



ReactDOM.render(<WidgetSelection />,   document.getElementById('aculistWidgetRoot'));



// WEBPACK FOOTER //
// ./src/index.js